// React
import React, {Component, useRef, useEffect} from 'react';
import {connect} from 'react-redux';
// Styles
import './styles.scss';
// Assets
import {arrowNextSvg, arrowPrevSvg} from "assets";

const EMBED_VIDEO_PATTERN = /(?:youtube\.com\/embed|youtube\.com\/watch|youtu\.be|player\.vimeo\.com|vimeo\.com|dailymotion\.com|wistia\.com|facebook\.com|fb\.watch|twitch\.tv)/i;
const VIDEO_FILE_PATTERN = /\.(mp4|webm|ogg|mov|avi|m4v|mkv)(\?.*)?$/i;

const MIME_TYPES = { mp4: 'video/mp4', webm: 'video/webm', ogg: 'video/ogg', mov: 'video/quicktime', avi: 'video/x-msvideo', m4v: 'video/mp4', mkv: 'video/x-matroska' };

const isEmbeddedVideo = (src) => EMBED_VIDEO_PATTERN.test(src || '');
const isVideoFile = (src) => VIDEO_FILE_PATTERN.test(src || '');
const getMimeType = (src) => {
    const ext = (src || '').split('?')[0].split('.').pop().toLowerCase();
    return MIME_TYPES[ext] || '';
};

const getEmbedSrc = (src) => {
    if (!src) return src;

    try {
        const url = new URL(src, window.location.href);
        url.searchParams.set('autoplay', '1');
        url.searchParams.set('mute', '1');
        url.searchParams.set('controls', '1');
        url.searchParams.set('playsinline', '1');
        url.searchParams.set('rel', '0');
        url.searchParams.set('modestbranding', '1');
        return url.toString();
    } catch {
        return src;
    }
};

function VideoNativeItem({ item, handleResponse }) {
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;
        const observer = new IntersectionObserver(
            ([entry]) => { entry.isIntersecting ? video.play().catch(() => {}) : video.pause(); },
            { threshold: 0.6 }
        );
        observer.observe(video);
        return () => observer.disconnect();
    }, []);

    return (
        <div className="lightbox_slider_item lightbox_slider_video">
            <div className="video">
                <video ref={videoRef} controls playsInline preload="auto" muted>
                    <source src={item.src} type={getMimeType(item.src)} />
                </video>
            </div>
            <div className="carousel-video-caption" onClick={() => handleResponse(item.value)}>
                {item.title}
            </div>
        </div>
    );
}

function Item(props) {
    const isVideo = props.item.element === 'video' || isVideoFile(props.item.src);

    if (isVideo && isEmbeddedVideo(props.item.src)) {
        return (
            <div className={`lightbox_slider_item lightbox_slider_video`}>
                <div className={"video lightbox_slider_embed"}>
                    <iframe
                        src={getEmbedSrc(props.item.src)}
                        title={props.item.title}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                    />
                </div>
                <div className="carousel-video-caption" onClick={() => props.handleResponse(props.item.value)}>
                    {props.item.title}
                </div>
            </div>
        )
    }

    if (isVideo) {
        return <VideoNativeItem item={props.item} handleResponse={props.handleResponse} />;
    }

    return (
        <div className={`lightbox_slider_item lightbox_slider_image`} onClick={() => window.open(props.item.link)}>
            <div className={"image"}>
                <div style={{backgroundImage: `url("${props.item.src}")`}}/>
            </div>
        </div>
    )
}

class CarouselMobile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uuid: this.getUuid(),
            scroll_left: 0
        }
    }

    getUuid = () => {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
        );
    }

    handleResponse = (value) => {
        const {incomingResponses} = this.props;
        if (value) {
            this.props.dispatch({type: 'synthetic', detail: {type: 'visitor_send_msg', msg: value}});

            incomingResponses(value);
        }
    }

    handlePagination = (e, type) => {
        var element = document.getElementById(`lightbox_${this.state.uuid}`),
            value = element?.scrollLeft,
            leftMax = element?.scrollWidth - element?.offsetWidth;

        switch (type) {
            case 'next':
                if (element?.scrollLeft === 0) {
                    value += 155;
                } else {
                    value += 150;
                }
                break;
            case 'prev':
                if (element?.scrollLeft >= leftMax) {
                    value -= 155;
                } else {
                    value -= 150;
                }
                break;
            default:
                break;
        }

        document.getElementById(`lightbox_${this.state.uuid}`).scrollTo({
            left: value,
            behavior: 'smooth',
        });
        this.setState({scroll_left: value});
    }

    handleDisplay = (type) => {
        var element = document.getElementById(`lightbox_${this.state.uuid}`),
            leftMax = element?.scrollWidth - element?.offsetWidth;
        const {scroll_left} = this.state;

        switch (type) {
            case 'prev':
                if (scroll_left <= 5) {
                    return 'hidden_action';
                }
                break;
            case 'next':
                if (scroll_left >= leftMax ?? 0) {
                    return 'hidden_action';
                }
                break;
            default:
                break;
        }

        return "";
    }

    render() {
        const {items} = this.props;
        const {uuid} = this.state;
        return (
            items?.length > 0 &&
            <div className={`lightbox_slider`}>
                <div>
                    <div className={`lightbox_slider_action prev ${this.handleDisplay('prev')}`}
                         onClick={(e) => this.handlePagination(e, "prev")}>{arrowPrevSvg()}</div>
                    <div id={`lightbox_${uuid}`} className={`lightbox_slider_content`}>
                        {
                            items.map((item, i) => {
                                return <Item item={item} handleResponse={this.handleResponse}
                                             incomingResponses={this.props.incomingResponses} key={i}/>
                            })
                        }
                    </div>
                    <div className={`lightbox_slider_action next ${this.handleDisplay('next')}`}
                         onClick={(e) => this.handlePagination(e, "next")}>{arrowNextSvg()}</div>
                </div>
            </div>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        data: state
    }
}

const action_carousel = connect(
    mapStateToProps
)(CarouselMobile);

export default action_carousel;
